<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <clipPath id="clip-path">
        <path id="Caminho_3693" data-name="Caminho 3693" d="M213-757a8,8,0,0,0,8-8,8,8,0,0,0-8-8,8,8,0,0,0-8,8A8,8,0,0,0,213-757Z" fill="none" clip-rule="evenodd"/>
      </clipPath>
      <clipPath id="clip-path-2">
        <path id="Caminho_3692" data-name="Caminho 3692" d="M205-757h16v-16H205Z" fill="none"/>
      </clipPath>
      <clipPath id="clip-path-3">
        <rect id="Retângulo_60" data-name="Retângulo 60" width="76" height="76" transform="translate(175 -803)" fill="none" stroke="#d7dce3" stroke-width="1"/>
      </clipPath>
      <clipPath id="clip-path-5">
        <path id="Caminho_3697" data-name="Caminho 3697" d="M213-773a8,8,0,0,0-8,8,8,8,0,0,0,8,8,8,8,0,0,0,8-8A8,8,0,0,0,213-773Z" class="fill-current" clip-rule="evenodd"/>
      </clipPath>
      <clipPath id="clip-path-7">
        <rect id="Retângulo_61" data-name="Retângulo 61" width="76" height="76" transform="translate(175 -803)" fill="none" stroke="#0353e9" stroke-width="1"/>
      </clipPath>
    </defs>
    <g id="Grupo_3586" data-name="Grupo 3586" transform="translate(-205 773)" clip-path="url(#clip-path)">
      <g id="Grupo_3585" data-name="Grupo 3585" clip-path="url(#clip-path-2)">
        <g id="Grupo_3584" data-name="Grupo 3584" style="isolation: isolate">
          <g id="Grupo_3583" data-name="Grupo 3583" clip-path="url(#clip-path-3)">
            <g id="Grupo_3582" data-name="Grupo 3582" clip-path="url(#clip-path-2)">
              <g id="Grupo_3581" data-name="Grupo 3581" transform="translate(205 -773)">
                <path id="Caminho_3690" data-name="Caminho 3690" d="M8,16A8,8,0,1,0,0,8,8,8,0,0,0,8,16Z" class="fill-current" stroke="#d7dce3" stroke-width="6"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="Grupo_3592" data-name="Grupo 3592" transform="translate(-205 773)" clip-path="url(#clip-path-5)">
      <g id="Grupo_3591" data-name="Grupo 3591" clip-path="url(#clip-path-2)">
        <g id="Grupo_3590" data-name="Grupo 3590" style="isolation: isolate">
          <g id="Grupo_3589" data-name="Grupo 3589" clip-path="url(#clip-path-7)">
            <g id="Grupo_3588" data-name="Grupo 3588" clip-path="url(#clip-path-2)">
              <g id="Grupo_3587" data-name="Grupo 3587" transform="translate(221 -757) rotate(180)">
                <path id="Caminho_3694" data-name="Caminho 3694" d="M8,16A8,8,0,1,0,0,8,8,8,0,0,0,8,16Z" fill="none" stroke="#0353e9" stroke-width="6" stroke-dasharray="20 33"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>   
</template>